var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"calc__container"},[_c('div',{staticStyle:{"width":"100%"},attrs:{"id":"tcpp-iframe-kfz"}})])}
var staticRenderFns = []

export { render, staticRenderFns }